// extracted by mini-css-extract-plugin
module.exports = {"wallet":"Wallet_wallet__2HOPe","account":"Wallet_account__xwizP","edit":"Wallet_edit__3zsFV","items":"Wallet_items__16nLR","header":"Wallet_header__1_HHd"};